module.exports = __webpack_public_path__ + "images/858e63914fcb0fd33e7f0b9ebcdb76bd.png";